import Delete from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import React from "react";
import FormTextField from "../../Common/FormTextField";
import {
  useConfigModeContext,
  useFormConfigContext,
} from "./ConfigFormContext";

const ConfigSynthesis: React.FC = () => {
  const { control, setValue } = useFormConfigContext();
  const { isReadOnly } = useConfigModeContext();
  return (
    <>
      <div className="flex justify-between items-center">
        <Typography className="text-xl font-semibold">Synthèse</Typography>
        {!isReadOnly && (
          <Button
            color="error"
            onClick={() => setValue("config.synthesis", undefined)}
          >
            <Delete />
          </Button>
        )}
      </div>

      <FormTextField
        minRows={4}
        multiline
        control={control}
        name="config.synthesis"
        label="Synthèse"
      />
    </>
  );
};
export default ConfigSynthesis;
